import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import {PrettyJsonModule} from 'angular2-prettyjson';
import { RvGridComponent } from './rv-grid.component';
import { Routes, RouterModule } from '@angular/router';
import{ ChartModule } from '../../../common/component/chart/chart.module';
import{ ChartComponent} from '../../../common/component/chart/chart.component';
import { AlertComponent } from '../../../common/component/alert/alert.component';
import { AlertModule } from '../../../common/component/alert/alert.module';
import{ ModalModule } from '../../../common/component/modal/modal.module';
import{ modalComponent} from '../../../common/component/modal/modal.component';
import{ rv_ModalModule } from '../../../common/component/rv_modal/rv_modal.module';
import{ rv_modalComponent} from '../../../common/component/rv_modal/rv_modal.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { FormsModule } from '@angular/forms';
import { DateTimeModule} from '../../../common/component/date-time/date-time.module';
import { NglDropdown } from 'ng-lightning';
import { NglModule   } from 'ng-lightning';

@NgModule({
    imports: [
        CommonModule,
        GridModule,
        DateInputsModule,
        PrettyJsonModule,
        RouterModule,
        ChartModule,
        AlertModule,
        ModalModule,
        rv_ModalModule,
        DialogModule,
        FormsModule,
        DateTimeModule,
        NglModule
    ],
    declarations: [RvGridComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [RvGridComponent, NglDropdown]
})
export class RvGridModule { }
